import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { WorkflowStepNames } from '../../../constants/constants';
import Routes from '../../../constants/routes';
import Notification from '../../Common/Notification';

const SendToDestinationWorkflowStep = ({ user, step, actions }) => {
    // Early exit if the step is invalid
    if (!user || !step || step.name !== WorkflowStepNames.SendToDestinationPage) {
        Notification("error", "Error", `Invalid Step Name: Expected ${WorkflowStepNames.SendToDestinationPage}, Actual: ${step?.name}`);
        return <Redirect to={Routes.LoginPage} />;
    }

    const redirectURL = user.redirectURL;
    const defaultDestination = step.defaultDestination;
    const destination = redirectURL || defaultDestination;

    // Use useEffect to handle side effects
    useEffect(() => {
        // Clear the login workflow from Redux state
        actions.clearLoginWorkflow();
    }, [actions]);

    return <Redirect to={destination} />;
};

SendToDestinationWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    actions: PropTypes.shape({
        clearLoginWorkflow: PropTypes.func.isRequired,
    }).isRequired,
};

export default SendToDestinationWorkflowStep;
